import React from 'react';
import { useLocation } from 'react-router-dom';


const LabHeaderInfo = (props) => {
    const location = useLocation();
    const { data }  = props;
  
    return (
        <>
            {Object.keys(data)?.length > 0 ?
                <div className="action-buttons">
                    <div className="card">
                        <div className="card-body d-flex justify-content-between">
                            <div className="d-flex">
                                <p className="action-key-tag"><i className="fa fa-money-bill"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{data?.headerOneLabel}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag"><i className="fa fa-regular fa-clock"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{data?.headerTwoLabel}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag"><i class="fa fa-vial"></i>&nbsp;:&nbsp;	</p>
                                <p className="action-value-tag">{data?.headerThreeLabel}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag" ><i className="fa fa-rupee-sign"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{data?.headerFourLabel}</p>
                            </div>
                        </div>
                    </div>
                </div> : null}

        </>
    )
};

export default LabHeaderInfo;